var cartQueue = Promise.resolve();
export var enqueueCartAction = function (action) {
    cartQueue = cartQueue
        .then(function () { return action(); })
        .catch(function (error) {
        // eslint-disable-next-line no-console
        console.error('Error in cart queue:', error);
    });
    return cartQueue;
};
